





























































import { Component, Prop, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';

import type { Concept } from '@/models/concept';
import type { User } from '@/models/user';
import { hasPermission } from '@/helpers/auth/permissionHelpers';
import { PERMISSIONS } from '@/helpers/auth/permissions';

@Component({
    name: 'ConceptsList',
    computed: {
        PERMISSIONS() {
            return PERMISSIONS;
        },
    },
    methods: { hasPermission },
})
export default class ConceptsList extends Vue {
    private tableSettings = {
        openedDetailed: Array<number>(),
        isStriped: true,
        isHoverable: true,
        isPaginated: false,
    };

    @Prop() private concepts: Concept[];
    @Prop() private searchQuery: string;
    @Prop() private isLoading: boolean;

    @Getter('account/userInfo') private userInfo: User;

    private rowClicked(row) {
        this.$emit('rowClicked', row);
    }
}
